<template>
  <v-card class="infoPost my-5 px-5 py-3" v-if="journey && visible()" @click="goTo()">
    <v-row align="center" justify="center">
      <v-col class="text-right pr-0" cols="2" md="1" style="max-width:32px; !important">
        <v-img src="@/assets/alert-circle-purple.png" class="mx-0" width="24px"> </v-img>
      </v-col>
      <v-col>
        <span class="infoTitle">
          Interaja com os conteúdos para avançar de etapa. Os quizzes serão disponibilizados nos próximos dias, fique ligado na plataforma. Veja quanto falta:
        </span>
        <div v-if="journey.ideias.meta - journey.ideias.atual > 0">
          <span class="infoTitle">
            {{ journey.ideias.meta - journey.ideias.atual }}
            <span v-if="journey.ideias.meta - journey.ideias.atual === 1">
              ideia
            </span>
            <span v-if="journey.ideias.meta - journey.ideias.atual > 1">
              ideias
            </span>
          </span>
        </div>
        <div v-if="journey.acoes.meta - journey.acoes.atual > 0">
          <span class="infoTitle">
            {{ journey.acoes.meta - journey.acoes.atual }}
            <span v-if="journey.acoes.meta - journey.acoes.atual === 1">
              ação
            </span>
            <span v-if="journey.acoes.meta - journey.acoes.atual > 1">
              ações
            </span>
          </span>
        </div>
        <div v-if="journey.quiz.meta - journey.quiz.atual > 0">
          <span class="infoTitle">
            {{ journey.quiz.meta - journey.quiz.atual }}
            <span v-if="journey.quiz.meta - journey.quiz.atual === 1">
              quiz
            </span>
            <span v-if="journey.quiz.meta - journey.quiz.atual > 1">
              quizzes
            </span>
          </span>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['journey']),
  },
  methods: {
    noContent() {
      return this.journey.ideias.meta <= this.journey.ideias.atual && this.journey.acoes.meta <= this.journey.acoes.atual && this.journey.quiz.meta <= this.journey.quiz.atual
    },
    visible() {
      if (this.journey.ideias.meta - this.journey.ideias.atual > 0 || this.journey.acoes.meta - this.journey.acoes.atual > 0 || this.journey.quiz.meta - this.journey.quiz.atual > 0) {
        return true
      } else {
        return false
      }
    },
    goTo() {
      this.$router.push('/')
    },
  },
}
</script>

<style></style>
